import React from 'react';
import cx from 'classnames';
import { slide as Menu } from 'react-burger-menu';
import lockerPNG from './locker.png';
import SettingsActions from '../weather/settings_actions';
import SettingsStore from '../weather/settings_store';

export default class UnlockFeature extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      settings: SettingsStore.getInitialState(),
    };
  }

  componentDidMount() {
    this.unsubscribe = SettingsStore.listen(this.onDataChange.bind(this));
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  onDataChange(data) {
    this.setState(data);
  }

  getActiveClass(key, value) {
    const selected = (this.state.settings.get(key) === value);
    return cx({ selected });
  }

  render() {
    const isOpen = this.state.settings.get('unlock_feature');
    return (
      <Menu isOpen={isOpen} customBurgerIcon={false} right onStateChange={this.handleStateChange}>
        <div className="feature">
          You can unlock this feature by:
          <hr />
          <button onClick={this.showSurvey} className="btn action">Taking a Pollfish Survey</button>
          <hr />
          <button className="btn disabled">Paying $0.99 <img src={lockerPNG} alt="locked"/></button>
          <hr />
          <button className="btn disabled">Watching a Video <img src={lockerPNG} alt="locked"/></button>
        </div>
      </Menu>
    );
  }

  handleStateChange(state) {
    SettingsActions.set('unlock_feature', state.isOpen);
  }

  showSurvey() {
    SettingsActions.set('unlock_feature', false);
    /* eslint no-undef:0 */
    Pollfish.showFullSurvey();
  }

}



// WEBPACK FOOTER //
// ./src/components/common/unlock_feature.js